import {Record, Map} from "immutable"

interface Properties {
    id: number
    name: string
    age: number
    year: number
    entranceYear: number
    graduateYear: number
    details: string
    contract: string
    master: boolean
}

const contracts = {
    enrollee: "Договор заключен на условиях целевого приёма (с абитуриентом)",
    student: "Договор заключен с обучающимся (со студентом)",
}

export class Student extends Record({
    id: undefined,
    name: undefined,
    age: undefined,
    year: undefined,
    entranceYear: undefined,
    graduateYear: undefined,
    details: undefined,
    contract: undefined,
    master: undefined,
}) implements Properties {
    id: number
    name: string
    age: number
    year: number
    entranceYear: number
    graduateYear: number
    details: string
    contract: string
    master: boolean

    constructor(values: Properties) {
        super(values)
    }

    get contractTitle() {
        return contracts[this.contract]
    }

    get period() {
        return this.graduateYear - this.entranceYear
    }
}

export type JsonData =  {
    id: number
    name: string
    age: number
    year: number
    entranceYear: number
    graduateYear: number
    details: string
    contract: string
    master: boolean
}

export const fromJs = ({
    id,
    name,
    age,
    year,
    entranceYear,
    graduateYear,
    details,
    contract,
    master,
}: JsonData): Student => new Student({
    id,
    name,
    age,
    year,
    entranceYear,
    graduateYear,
    details,
    contract,
    master,
})

export type Students = Map<number, Student>